<template>
    <nav class="xl:block lg:block md:hidden">
        <ul class="main-menu flex items-center">
            <li class="mr-spc9">
                <router-link class="text-lg font-medium inline-block text-white tracking-spc1" to="#">Pricing</router-link>
            </li>
            <li class="mr-spc4">
                <router-link class="text-lg font-medium inline-block text-white tracking-spc1" to="#">Templates</router-link>
            </li>
            <li class="mr-spc4">
                <router-link class="text-lg font-medium inline-block text-white tracking-spc1" to="#">Apps</router-link>
            </li>
            <li class="mr-spc4">
                <router-link class="text-lg font-medium inline-block text-white tracking-spc1" to="#">Features</router-link>
            </li>
            <li class="mr-spc4">
                <router-link class="text-lg font-medium inline-block text-white tracking-spc1" to="#">Customers</router-link>
            </li>
            <li class="dots mr-spc12">
                <router-link class="text-lg font-medium inline-block text-white tracking-spc1 flex items-center" to="#">
                    <span class="w-spc10 h-spc10 bg-white rounded-full mr-spc11"></span>
                    <span class="w-spc10 h-spc10 bg-white rounded-full mr-spc11"></span>
                    <span class="w-spc10 h-spc10 bg-white rounded-full"></span>
                </router-link>
            </li>
            <li class="mr-spc4">
                <router-link class="text-lg font-medium inline-block text-white tracking-spc1" to="#">Login</router-link>
            </li>
            <li>
                <ThemeButton title="Create An Account" url="#" />
            </li>
        </ul>
    </nav>
</template>

<script>
    import ThemeButton from "./ThemeButton";
    export default {
        name: "Navbar",
        components: {ThemeButton}
    }
</script>

<style scoped>

</style>